import { DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, input } from '@angular/core'

export interface BookingProductRefundPolicy {
    customerRefundableUntil?: Date | null
    refundPolicyPending?: boolean
}

@Component({
    selector: 'app-booking-product-refund-policy',
    standalone: true,
    imports: [DatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if (policy().customerRefundableUntil !== undefined || policy().refundPolicyPending) {
            <small class="d-block text-secondary" data-testid="summary-product-refund-policy">
                @if (policy().refundPolicyPending) {
                    Refundable before cancellation cutoff
                } @else if (policy().customerRefundableUntil) {
                    Refundable if cancelled before {{ policy().customerRefundableUntil | date:'d MMM y, HH:mm' }}
                } @else { Non-refundable }
            </small>
        }
    `,
})
export class BookingProductRefundPolicyComponent {
    policy = input.required<BookingProductRefundPolicy>()
}
